export enum PropertyType {
    Text,
    Number,
    ConnectionPoint,
    VariableType,
    VariableSubType,
    Qualifier,
    Unit,
    Frequency,
    FlatMode,
    Boolean,
    AggregationMode,
    MultiGroup,
    MultiGroupType,
    Template, // Not to be used anymore, obsolete
    ValidationConfigMode,
    ApprovalStrategyGuid,
    DataType,
    Queries,
    UnitWithEmpty,
    Interpolation,
    Color,
    Symbol,
    VariablesAndUnit,
    Group,
    Select,
    ApprovalLevel,
    Severities,
    Categories,
    SortBy,
    DateOrder,
    UserFields,
    UserName,
    Password,
    ConnectionPointQuerySet,
    Background,
    Time,
    Conversion,
    Application,
    TriggerEventSelector,
    ApprovalMultiLevel,
    VariableTypes,
    ValueType,
    ViewModel,
    File,
    MailingJobCondition,
    Documentation,
    TicketStatusMultiLevel,
    AlarmCategories,
    MultiQuality,
    MultiCategory,
    DashboardSelector,
    MultiSelect,
    QuerySearchBar,
    DateTimePicker
}